import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "currentColor", d: "m10 8.94 3.71-3.71 1.06 1.06-3.7 3.71 3.7 3.71-1.06 1.06-3.71-3.7-3.71 3.7-1.06-1.06L8.94 10 5.23 6.29l1.06-1.06z" }));
export {
  l as S
};
//# sourceMappingURL=close-BypPN932.js.map
